/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { TabScrollButtonProps } from "@mui/material";

import {
  ChevronLeftIcon,
  ChevronRightIcon
} from "@dotnet/telematics-design-system";

import Button, {
  BUTTON_COLORS,
  BUTTON_SIZES,
  BUTTON_VARIANTS
} from "../Button/Button";
import { DIRECTIONS } from "./types";

const SegmentedToggleButtons = (
  scrollButtonLeftMargin: any,
  scrollButtonRightMargin: any,
  segmentedToggleButtons: any,
  props: TabScrollButtonProps
) => {
  const isLeftButton = props.direction === DIRECTIONS.Left;
  const { slotProps, ...restProps } = props;

  return (
    <Button
      {...restProps}
      color={BUTTON_COLORS.White}
      size={BUTTON_SIZES.Small}
      variant={BUTTON_VARIANTS.IconOnly}
      icon={isLeftButton ? <ChevronLeftIcon /> : <ChevronRightIcon />}
      css={css([
        segmentedToggleButtons,
        isLeftButton ? scrollButtonLeftMargin : scrollButtonRightMargin
      ])}
    />
  );
};

export default SegmentedToggleButtons;
